import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { blobToFile } from '../../utils';
import apiService from '../api/service';
import adapter from './adapter';
import service from './service'

const initialState = {
  name: 'event',
  _payload: null,
  status: 'idle',
  error: '',
  data: {},
  selectedTicket: {},
  pdf_field: {
    cover_title: true,
    cover_main_image: true,
    cover_logo: true,
    cover_name: true,
    cover_approach: true,
    cover_issue: true,
    cover_datetime: true,
    cover_location: true,
    cover_type: true,
    cover_price: true,
    detail_title: true,
    detail_image: true,
    detail_description: true,
    other_testimonial: true,
    other_gallery: true,
    other_guests: true,
  }
}

export const fetchEvent = createAsyncThunk(
  `${initialState.name}/fetchEvent`,
  async (id) => {
    const data = await service.getData(id);
    return data;
  }
);

export const createEvent = createAsyncThunk(
  `${initialState.name}/createEvent`,
  async (options) => {
    const data = options
    console.log('createEvent', {data})

    const needToHandleGallery = data.gallery && data.gallery.length > 0
    const needToHandleLocationOnline = data.location_online_id === null && data.location_online_url !== null

    const requestBodyBasic = adapter.formToRequestBody(data)

    if(needToHandleLocationOnline){
      requestBodyBasic.lokasiOnline = [adapter.sub.location_online.formToRequestBody(data)]
    }

    const requestBodyExtended = adapter.sub.extension.formToRequestBody(data)
    const requestBody = {...requestBodyBasic, activityOrganizing: requestBodyExtended}

    const promises = []

    const promise1 = await apiService.create('events', requestBody)
    const id = promise1.eventId
    promises.push(promise1)

    if(id){
      const requestBodyFiles = await adapter.sub.image.formToRequestBody({image: data.new_image, thumbnail: data.new_image})
      const promise2 = await apiService.update('events', id, requestBodyFiles)
      promises.push(promise2)

      if(needToHandleGallery){
        let filesByBlob = {}
        for (let index = 0; index < data.gallery.length; index++) {
          const { blob, name, type } = data.gallery[index];
          const file = await blobToFile(blob, name, type)
          filesByBlob[blob] = file
        }

        const promise3 = service.handleGallery(id, filesByBlob)
        promises.push(promise3)
      }
    }

    return await Promise.all(promises);
  }
);

export const setSelectedTicket = createAsyncThunk(
  `${initialState.name}/setSelectedTicket`,
  async (options) => {
    return options;
  }
);

export const updateEvent = createAsyncThunk(
  `${initialState.name}/updateEvent`,
  async (options) => {
    const {id, data} = options

    const needToHandleImage = data.new_image && data.new_image.blob
    const needToHandleGallery = data.gallery && data.gallery.length > 0
    const needToHandleGalleryDelete = data.gallery_holder_delete && data.gallery_holder_delete.length > 0
    const needToDeleteLocationFromBasicRequestBody = data.location_id
    const needToHandleLocationOnline = data.location_online_need_update
    const needToCreateLocationOnline = needToHandleLocationOnline && data.location_online_is_empty

    const requestBody = adapter.formToRequestBody(data)

    if(needToCreateLocationOnline){
      requestBody.lokasiOnline = [adapter.sub.location_online.formToRequestBody(data)]
    }

    const requestBody2 = adapter.sub.extension.formToRequestBody(data)

    // Remove location from basic request body to avoid duplication
    let requestBody4 = []
    if(requestBody.lokasi){
      requestBody4 = [...requestBody.lokasi][0]
      if(needToDeleteLocationFromBasicRequestBody){
        delete requestBody.lokasi
      }
    }

    const promises = []

    // promise1 need to be done first before handle gallery or other child field
    const promise1 = await apiService.update('events', id, requestBody)

    const promise2 = apiService.update('events_extension', data.pkId, requestBody2)
    promises.push(promise1)
    promises.push(promise2)

    if(needToHandleImage){
      const requestBody3 = adapter.sub.image.formToRequestBody({image: data.new_image, thumbnail: data.new_image})
      const promise3 = apiService.update('events', id, requestBody3)
      promises.push(promise3)
    }

    if(needToHandleGallery){
      let filesByBlob = {}
      for (let index = 0; index < data.gallery.length; index++) {
        const { blob, name, type } = data.gallery[index];
        const file = await blobToFile(blob, name, type)
        filesByBlob[blob] = file
      }

      const promise4 = service.handleGallery(id, filesByBlob)
      promises.push(promise4)
    }

    if(needToHandleGalleryDelete){
      const promise5 = service.handleGalleryDelete(data.gallery_holder_delete)
      promises.push(promise5)
    }

    if(requestBody.lokasi){
      const promise6 = data.location_id ? apiService.update('events_location', data.location_id, requestBody4) : false
      promises.push(promise6)
    }

    if(needToHandleLocationOnline && data.location_online_is_empty === false){
      const requestBody7 = adapter.sub.location_online.formToRequestBody(data)
      const promise7 = apiService.update('event_location_online', data.location_online_id, requestBody7)
      promises.push(promise7)
    }

    return await Promise.all(promises);
  }
);

export const eventSlice = createSlice({
  name: initialState.name,
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    setPdfField(state, action){
      state.pdf_field = action.payload
    }
  },
  extraReducers: {
    [fetchEvent.pending]: (state) => {
      state.status = "loading";
    },
    [fetchEvent.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const payload = adapter.responseBodyToRender(action.payload);
      state.data = payload;
    },
    [fetchEvent.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [setSelectedTicket.fulfilled]: (state, action) => {
      state.selectedTicket = action.payload
    }
  }
})

export const {
  setStatus,
  setPdfField
} = eventSlice.actions

export default eventSlice.reducer
